import { useCallback, useState } from "react";
import { getCategoryFileContent } from "@/services/api/categories";
import { toast } from "@/shared/lib/toast";
import type { FileItem } from "../types";

interface UseFileDownloadInput {
  file: Pick<FileItem, "id" | "name">;
}

export function useFileDownload({ file }: UseFileDownloadInput) {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFile = useCallback(async () => {
    if (!file?.id) return;

    setIsDownloading(true);
    try {
      const blob = await getCategoryFileContent(file.id);
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = file.name || "file";
      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(url);
    } catch {
      toast.error(
        "Download failed",
        "We couldn't download this file. Please try again."
      );
    } finally {
      setIsDownloading(false);
    }
  }, [file.id, file.name]);

  return { isDownloading, downloadFile };
}
